
import { defineComponent, onBeforeMount, ref } from 'vue';
import Moment from 'moment';
import { invokeGetUserRole } from '@/utils/admin/master_service';

export default defineComponent({
  setup() {
    const userRoles = ref();
    // const systemAdminShow = ref(false);
    // const ProxyAdminShow = ref(false);
    const viewProxy = ref(false);
    const operationTabShow = ref(false);
    const taskManagementShow = ref(false);
    const systemSettingsShow = ref(false);
    // const transformSystemSettingsShow = ref(false);
    const proxyAdminShow = ref(false);
    const programAdminShow = ref(false);
    const masterShow = ref(false);
    const assignRoleShow = ref(false);
    const emailManagementShow = ref(false);
    const offCycleshow = ref(false);
    const showReport = ref(false);
    const showSegmentedComms = ref(false);
    // const diffAccessTabShow = ref(false);

    onBeforeMount(async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const userRole: any = await invokeGetUserRole('/getUserRole');
        const usrObj = userRole;
        userRole.value = userRole.user_roles;
        localStorage.setItem('user_roles', userRole.value);
        if (usrObj) {
          if (usrObj.last_accessed_on) {
            //  console.log('inside last accessed');
            localStorage.setItem('lastAccess', Moment(usrObj.last_accessed_on).format('MMM Do YYYY, h:mm a'));
          }
          if (usrObj.user_fullName) {
            localStorage.setItem('userName', usrObj.user_fullName);
          }
          if (usrObj.user_email) {
            localStorage.setItem('email', usrObj.user_email);
          }
          if (usrObj.user_key) {
            localStorage.setItem('user_key', usrObj.user_key);
          }
        }
        // if (usrObj && usrObj.user_ad_profile && usrObj.user_ad_profile.firstName) {
        //   if (usrObj.user_ad_profile.firstName && usrObj.user_ad_profile.lastName) {
        //     localStorage.setItem('userName', `${usrObj.user_ad_profile.firstName} ${usrObj.user_ad_profile.lastName}`);
        //   }
        // }
        // // console.log('checking for email');
        // if (usrObj && usrObj.user_ad_profile && usrObj.user_ad_profile.email) {
        //   localStorage.setItem('email', usrObj.user_ad_profile.email);
        // } else {
        //   const user = JSON.parse(localStorage.getItem('user') || '{}');
        //   if (user) localStorage.setItem('email', user.email);
        // }
        // console.log('checking for user keyu');
        // if (usrObj && usrObj.user_key) {
        //   console.log('inide user key');
        //   localStorage.setItem('user_key', usrObj.user_key);
        // }
        // if (usrObj && usrObj.last_accessed_on) {
        //   console.log('inside last accessed');
        //   localStorage.setItem('lastAccess', Moment(usrObj.last_accessed_on).format('MMM Do YYYY, h:mm a'));
        // }
        if (usrObj && usrObj.diff_access_status) {
          console.log('inside last accessed');
          localStorage.setItem('diff_access_status', usrObj.diff_access_status);
        }
        if (userRole.value.includes('System Admin')) {
          // diffAccessTabShow.value = true;
          operationTabShow.value = true;
          taskManagementShow.value = true;
          offCycleshow.value = true;
          systemSettingsShow.value = true;
          proxyAdminShow.value = true;
          // transformSystemSettingsShow.value = true;
          programAdminShow.value = true;
          masterShow.value = true;
          assignRoleShow.value = true;
          viewProxy.value = true;
          emailManagementShow.value = true;
          showReport.value = true;
          showSegmentedComms.value = true;
        }
        if (userRole.value.includes('System Admin View Access')) {
          operationTabShow.value = true;
          taskManagementShow.value = true;
          offCycleshow.value = true;
          programAdminShow.value = true;
        }
        if (userRole.value.includes('Program Admin')) {
          operationTabShow.value = true;
          taskManagementShow.value = true;
          offCycleshow.value = true;
          programAdminShow.value = true;
        }
        if (userRole.value.includes('Proxy Admin')) {
          console.log('inside proxy Admin');
          proxyAdminShow.value = true;
          viewProxy.value = true;
          showReport.value = true;
          showSegmentedComms.value = true;
        }
        if (userRole.value.includes('Community Manager')) {
          console.log('inside Community Manager');
          proxyAdminShow.value = true;
          viewProxy.value = true;
          taskManagementShow.value = true;
          offCycleshow.value = true;
          showReport.value = true;
          showSegmentedComms.value = true;
        }
        if (userRole.value.includes('Knowledge Manager')) {
          viewProxy.value = true;
          showReport.value = true;
          showSegmentedComms.value = true;
        }
        if (userRole.value.includes('Guru')) {
          viewProxy.value = true;
          showReport.value = true;
          showSegmentedComms.value = true;
        }
        if (userRole.value.includes('Master Guru')) {
          viewProxy.value = true;
          showReport.value = true;
          showSegmentedComms.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    });
    return {
      userRoles,
      viewProxy,
      operationTabShow,
      taskManagementShow,
      systemSettingsShow,
      // transformSystemSettingsShow,
      proxyAdminShow,
      programAdminShow,
      masterShow,
      assignRoleShow,
      emailManagementShow,
      showReport,
      showSegmentedComms,
      offCycleshow,
      // diffAccessTabShow,
    };
  },
});
